import type { Theme } from '@mui/material/styles';

export const primaryCtaGradient = (theme: Theme): string => `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`;

export const gradientButtonSx = {
    textTransform: 'none' as const,
    background: primaryCtaGradient,
    color: 'white',
    '&:hover': { opacity: 0.9, background: primaryCtaGradient }
};
